/* Natua · "Ver más reseñas" (divulgación progresiva), sin dependencias.
   La sección (natua-reviews.liquid) dibuja en la lista solo las primeras (data-initial) y deja el resto dentro de bloques
   <template data-n-rv-chunk> de data-step tarjetas cada uno: así las reseñas que todavía nadie ve no cuentan en el DOM ni pasan por
   estilos, diseño o pintura. Cada toque en el botón muestra otras data-step (clona el siguiente bloque), el botón dice cuántas
   faltan y desaparece al mostrar todas. El foco pasa a la primera reseña nueva (tabindex -1 solo mientras la tiene) y el movimiento
   respeta prefers-reduced-motion. Sin JavaScript se ven las primeras y el botón queda oculto.
   En el editor de temas la sección dibuja TODAS las tarjetas (sin <template>) y aquí se ocultan las que pasan de las primeras: al
   seleccionar una reseña oculta se muestran todas hasta ella. */
if (!customElements.get('natua-reviews-list')) {
  class NatuaReviewsList extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const list = this.querySelector('.n-rv__list');
      const wrap = this.querySelector('[data-n-rv-more]');
      const button = wrap ? wrap.querySelector('button') : null;
      const label = button ? button.querySelector('[data-n-rv-more-text]') : null;
      if (!list || !button || !label) return;

      // Tarjetas dibujadas en orden de aparición (los bloques de app ocupan todo el ancho y no cuentan)
      const cards = Array.from(list.children).filter((item) => item.tagName === 'LI' && !item.classList.contains('n-rv__item--app'));
      const initial = Math.max(1, parseInt(this.dataset.initial, 10) || 4);
      // Pendientes en orden: tarjetas ya dibujadas que pasan de las primeras (editor de temas) y bloques <template> con el resto
      const queue = [];
      cards.slice(initial).forEach((item) => queue.push({ item, count: 1 }));
      list.querySelectorAll(':scope > template[data-n-rv-chunk]').forEach((item) => queue.push({ item, count: item.content.children.length }));
      if (!queue.length) return;

      this.ready = true;
      this.wrap = wrap;
      this.label = label;
      this.queue = queue;
      this.baseText = label.textContent.trim();
      this.step = Math.max(1, parseInt(this.dataset.step, 10) || 6);

      queue.forEach(({ item }) => {
        if (item.tagName === 'LI') item.hidden = true;
      });
      this.update();

      button.addEventListener('click', () => this.reveal(this.step, true));
      // Editor de temas: seleccionar una reseña que está oculta muestra todas hasta ella para poder verla
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.queue.findIndex(({ item }) => item.contains(event.target));
        if (index > -1) this.reveal(this.queue.slice(0, index + 1).reduce((sum, entry) => sum + entry.count, 0), false);
      });
    }

    // Muestra al menos `count` tarjetas más (los bloques salen completos: cada uno trae `step`)
    reveal(count, fromUser) {
      const batch = [];
      while (this.queue.length && batch.length < count) {
        const { item } = this.queue.shift();
        if (item.tagName === 'TEMPLATE') {
          const cards = Array.from(item.content.children);
          item.before(item.content);
          item.remove();
          batch.push(...cards);
        } else {
          item.hidden = false;
          batch.push(item);
        }
      }
      if (!batch.length) return;
      if (fromUser) batch.forEach((item) => item.classList.add('is-new'));
      // Primero el foco a la reseña nueva y después se oculta el botón (así el foco nunca se pierde)
      if (fromUser) this.focusCard(batch[0]);
      this.update();
    }

    update() {
      const left = this.queue.reduce((sum, entry) => sum + entry.count, 0);
      this.label.textContent = `${this.baseText} (${left})`;
      this.wrap.hidden = left === 0;
    }

    focusCard(item) {
      item.setAttribute('tabindex', '-1');
      item.addEventListener('blur', () => item.removeAttribute('tabindex'), { once: true });
      item.focus({ preventScroll: true });
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      item.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  customElements.define('natua-reviews-list', NatuaReviewsList);
}
